module.exports = __webpack_public_path__ + "static/media/logo.light.d5fbc8ce.png";